import { registerHandler } from "../handler";
import { send } from "@utils/fetch";
import { captureException } from "@utils/error";
import Cookies from "js-cookie";

function trackEvent(event: string, data: JsonObject) {
  return send("POST", "/pixel/v1/i/iterablePurchaseTracking/", {
    event,
    data,
  }).catch((e: any) => {
    captureException(e, "IterablePixel-Failed to fetch");
  });
}

export default function registerHandlers() {
  registerHandler("purchase", ({ plan, userId }) => {
    const iterableEndUserId = Cookies.get("iterableEndUserId");
    const iterableEmailCampaignId = Cookies.get("iterableEmailCampaignId");
    const iterableTemplateId = Cookies.get("iterableTemplateId");

    if (iterableEndUserId && iterableEmailCampaignId && iterableTemplateId) {
      const iterableParams = {
        user: {
          email: iterableEndUserId,
          userId,
          preferUserId: true,
          mergeNestedObjects: true,
        },
        items: [
          {
            id: plan.braintree_id,
            sku: plan.braintree_id,
            name: plan.braintree_id,
            description: plan.braintree_id,
            categories: [plan.braintree_id],
            price: plan.price,
            quantity: 1,
          },
        ],
        campaignId: parseInt(iterableEmailCampaignId, 10),
        templateId: parseInt(iterableTemplateId, 10),
        total: plan.price,
      };
      trackEvent("purchase", iterableParams);
    }
  });
}
